import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'

export default {
  getMenu: () => {
    const query = gql`
      query {
        getMenu {
          id
          name
          code
          parentID
          action
        }
      }
    `
    return graphqlAjax('get', query, null)
  },
  getAllPermissionsSets: () => {
    const query = gql`
      query {
        getAllPermissionsSets {
          id
          name
          code
          parentID
          action
        }
      }
    `
    return graphqlAjax('get', query, null)
  }
}
